// Exports
export * from './Logout';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/user/logout/index.tsx